export function SkipLink() {
  return (
    <a className="skip-link" href="#main-content">
      Saltar al contenido principal
    </a>
  )
}
